import { isDefined } from '@sgme/fp';
import { scheduledRunsApi } from 'apiConnector/scheduledRun/scheduledRuns';
import { ofType } from 'redux-observable';
import { EMPTY, of } from 'rxjs';
import { catchError, filter, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { scheduledRunActions } from 'state/scheduledRuns/actions';
import type { EpicWithThunk } from 'state/state.common';
import { getWorkspaceType } from 'state/workspaces/tabs/tabs.selector';
import { type HttpError, toTypedError } from 'utils/http/httpClient.model';

export function validateQuotesEpic(): EpicWithThunk {
  return (actions$, state$, { selectors: { isFeatureEnabled }, httpClient }) => {
    const { validateQuotes } = scheduledRunsApi(httpClient);

    return actions$.pipe(
      ofType('SCHEDULED_RUN_VALIDATE_QUOTES'),
      withLatestFrom(state$),
      filter(([, state]) => isFeatureEnabled(state, 'scheduledRunsParis')),
      mergeMap(([{ id, validateRequest }, state]) => {
        if (!isDefined(validateRequest.quotes) || validateRequest.quotes.length <= 0) {
          return EMPTY;
        }
        return validateQuotes(validateRequest, getWorkspaceType(state, id)).pipe(
          map(res => scheduledRunActions.validateQuotesSucceeded(id, res)),
          catchError((err: HttpError) => {
            return of(scheduledRunActions.validateQuotesFailed(id, toTypedError('Pricing Runs DIY', err)));
          }),
        );
      }),
    );
  };
}
